import {FC} from 'react'
import useSize from '../../../hooks/useSize'
import {NUKLIE_ICON} from './constants'
import styles from './nuklie.module.css'

// Fica ao lado da bolha do Chatwoot, que só aparece em telas acima de 1000px.
export const NuklieFloatingButton: FC<{onClick: () => void}> = ({onClick}) => {
  const {width} = useSize()

  return (
    <button
      type='button'
      className={styles.floatingButton}
      style={{right: width > 1000 ? '96px' : '20px'}}
      onClick={onClick}
      title='Abrir o Atendimento Nuklie'
    >
      <img src={NUKLIE_ICON} alt='' className={styles.floatingIcon} />
      Conversas
    </button>
  )
}
